module.exports = __webpack_public_path__ + "media/src/images/site-top/article1-c5d44556a0d2eed21468e8755cb852e4.jpg";